import clsx from 'clsx';

export type ArticleCardSize = 'sm' | 'md' | 'lg';

export type ArticleCardProps = {
  linkText?: string;
  image: React.ReactNode;
  title?: string;
  body?: string;
  href?: string;
  direction?: 'vertical' | 'horizontal';
  size?: ArticleCardSize;
};

export const ArticleCard = ({
  linkText = 'Les artikkel',
  image,
  title = '',
  body,
  href,
  size = 'lg',
  direction = 'horizontal',
  ...rest
}: ArticleCardProps) => {
  return (
    <article
      className={clsx(
        'flex',
        'group',
        'relative',
        'w-full',
        'flex-col',
        'max-w-full',
        'overflow-hidden',
        {
          'md:flex-row': direction === 'horizontal',
          // 'max-w-lg': size === 'lg' && direction === 'vertical',
          // 'max-w-sm': size === 'md' && direction === 'vertical',
          // 'max-w-[180px]': size === 'sm' && direction === 'vertical',
          // 'md:flex-row-reverse': imagePosition === 'after' && large,
          // 'flex-col': imagePosition === 'before' && small,
        }
      )}
    >
      {/* Image container */}
      <div
        className={clsx('aspect-[16/9] w-full', {
          'max-w-xl': size === 'lg' && direction === 'horizontal',
          'max-w-xs': size === 'md' && direction === 'horizontal',
          'aspect-square max-w-[80px]':
            size === 'sm' && direction === 'horizontal',
        })}
      >
        <figure className={clsx('w-full', 'h-full', 'object-cover-child-img')}>
          {typeof image === 'string' ? (
            <img src={image} alt="Preview image" />
          ) : (
            image
          )}
        </figure>
      </div>

      {/* Text Container */}
      <div
        className={clsx('flex', 'justify-between', 'flex-col', {
          // 'w-full': !large,
          // 'md:w-[50%]': large,
          // 'p-4': small,
          'p-10': size === 'lg' && direction === 'horizontal',
          'py-5': size === 'lg' && direction === 'vertical',
          'p-6': size === 'md' && direction === 'horizontal',
          'px-4 py-1': size === 'sm',
          'px-0': direction === 'vertical',
        })}
      >
        <h3
          className={clsx('break-words', 'group-hover:underline', {
            'hd-2xl': size === 'lg' && direction === 'horizontal',
            'hd-lg':
              (size === 'md' && direction === 'horizontal') ||
              (size === 'lg' && direction === 'vertical'),
            'hd-base':
              (size === 'sm' && direction === 'horizontal') ||
              (size === 'md' && direction === 'vertical') ||
              (size === 'sm' && direction === 'vertical'),
            'pt-4 pb-2': size === 'md' && direction === 'vertical',
          })}
        >
          {title}
        </h3>
        <p
          className={clsx('text-neutral-70', {
            'body-md': size === 'lg',
            'body-sm': size === 'md',
            'mb-5': size === 'lg',
            'mb-2': size === 'md',
            hidden: size === 'sm',
          })}
        >
          {body}
        </p>
      </div>
    </article>
  );
};

export default ArticleCard;
